import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { OfferType, WatchListResponse } from '@/types';
import { GET_WATCH_LIST } from '@/constants';

export const useGetWatchList = ({
  offerType,
  page,
  project,
}: {
  offerType?: OfferType;
  page: number;
  project?: boolean;
}) =>
  useQuery({
    queryKey: ['watchList', offerType, page, project],
    queryFn: async () => {
      const qs = new URLSearchParams({ pageNum: String(page) });
      if (offerType) qs.set('offerType', offerType);
      if (project !== undefined) qs.set('project', String(project));
      const { data } = await axios.get<WatchListResponse>(`${GET_WATCH_LIST}?${qs.toString()}`);
      return data;
    },
    enabled: project === true || Boolean(offerType),
    refetchOnWindowFocus: false,
    gcTime: 0,
    staleTime: 0,
  });
